import { Account } from '@/models/Account'
import { InviteAccount } from '@/models/InviteAccount'
import { AgencyModel } from '@/models/Agency'
import { AdvertiserModel } from '@/models/Advertiser'
import { SystemOwnerModel } from '@/models/SystemOwner'

const actions = {
  async GET_ACCOUNT_LIST(
    { commit },
    { keyword, systemOwnerId, belongType, pageSize, pageNo } = {},
  ) {
    commit('SET_LOADING', 'searchResult')
    const searchResult = await Account.search({
      keyword,
      systemOwnerId,
      belongType,
      pageSize,
      pageNo,
    })
    commit('SET_SEARCH_RESULT', searchResult)
    commit('CLEAR_LOADING', 'searchResult')
  },
  async GET_INVITATION_LIST(
    { commit },
    {
      keyword,
      isExpiredOnly,
      belongType,
      pageSize,
      pageNo,
      sortKey,
      sortDirection,
    } = {},
  ) {
    commit('SET_LOADING', 'searchInvitationsResult')
    const searchResult = await InviteAccount.search({
      keyword,
      isExpiredOnly,
      belongType,
      pageSize,
      pageNo,
      sortKey,
      sortDirection,
    })
    commit('SET_SEARCH_INVITATIONS_RESULT', searchResult)
    commit('CLEAR_LOADING', 'searchInvitationsResult')
  },
  async GET_SYSTEM_OWNER_LIST({ commit }) {
    commit('SET_LOADING', 'systemOwnerList')
    const searchResult = await SystemOwnerModel.getList()
    commit('SET_SYSTEM_OWNER_LIST', searchResult)
    commit('CLEAR_LOADING', 'systemOwnerList')
  },
  async GET_ADVERTISER_LIST({ commit }, { keyword }) {
    commit('SET_LOADING', 'advertiserList')
    const searchResult = await AdvertiserModel.search({ keyword })
    commit('SET_ADVERTISER_LIST', searchResult)
    commit('CLEAR_LOADING', 'advertiserList')
  },
  CLEAR_AGENCY_LIST({ commit }) {
    commit('SET_AGENCY_LIST', [])
  },
  async GET_AGENCY_LIST({ commit }, { keyword }) {
    commit('SET_LOADING', 'agencyList')
    const searchResult = await AgencyModel.searchAgency({ keyword })
    commit('SET_AGENCY_LIST', searchResult)
    commit('CLEAR_LOADING', 'agencyList')
  },
  CLEAR_ADVERTISER_LIST({ commit }) {
    commit('SET_ADVERTISER_LIST', [])
  },
  async GET_ADVERTISER_LIST_FOR_SEARCH({ commit }, { minPermissionLevel }) {
    commit('SET_LOADING', 'advertiserListForSearch')
    const searchResult = await AdvertiserModel.search({ minPermissionLevel })
    commit('SET_ADVERTISER_LIST_FOR_SEARCH', searchResult)
    commit('CLEAR_LOADING', 'advertiserListForSearch')
  },
  async GET_AGENCY_LIST_FOR_SEARCH({ commit }, { minPermissionLevel }) {
    commit('SET_LOADING', 'agencyListForSearch')
    const searchResult = await AgencyModel.searchAgency({ minPermissionLevel })
    commit('SET_AGENCY_LIST_FOR_SEARCH', searchResult)
    commit('CLEAR_LOADING', 'agencyListForSearch')
  },
  // async ADD_ADVERTISER({ commit, dispatch, state }, { item }) {
  //   await AdvertiserApi.addAdvertiser(item)
  // },
  // async EDIT_ADVERTISER({ commit, dispatch, state }, { id, body }) {
  //   await AdvertiserApi.editAdvertiser(id, body)
  // }
}

export default actions
